import { z } from 'zod'

export const MachineRowSchema = z.object({
  machine_code:      z.string(),
  store_code:        z.string(),
  machine_name:      z.string().nullable(),
  machine_number:    z.string().nullable(),
  type_id:           z.number().nullable(),
  model_id:          z.string().nullable(),
  play_price:        z.number().nullable(),
  notes:             z.string().nullable(),
  is_active:         z.boolean(),
  meter_unit_price:  z.number(),
  out_meter_count:   z.number(),
  organization_id:   z.string(),
  billing_order:     z.number().nullable().optional(),
  round_order:       z.number().nullable().optional(),
  // SPEC-MACHINE-FLOOR-EDIT-V1 (D-579): floor をここに書かないと safeParse が黙って捨てる
  //   (zod の既定は unknown key の strip)。捨てられると画面にも巡回のフロアタブにも出ない。
  floor:             z.string().nullable().optional(),
  // ★D-335 の設置日も同じ理由で落ちていた。落ちていると編集フォームのプリフィルが常に空になり、
  //   保存のたびに installed_at: '' → null が送られて設置日が消える。ここで拾って止める。
  installed_at:      z.string().nullable().optional(),
  created_at:        z.string().nullable(),
  updated_at:        z.string().nullable(),
})
